declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_left_read_only_foo extends $mol_object {
		bar2( next?: number ): number
		bar1( ): ReturnType< $mol_view_tree2_to_js_test_ex_left_read_only_foo['bar2'] >
	}
	
}

//# sourceMappingURL=left_read_only.view.tree.d.ts.map